import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import { IAddHolidayModal } from '@/interfaces/holiday.model';
// import { IOffice } from '@/interfaces/officelocation.model';
import { IOfficeResponse } from '@/pages/HRM/HrmSettings/OfficeLocation/OfficeLocation';
import { showToastNotification } from '@/utility/helper';
import { errorTypes } from '@/utility/validation';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Modal, Spinner } from 'reactstrap';
interface IHolidayModalForm {
  // officeId: string;
  holidayName: string;
  holidayDate: string;
  description: string;
}
// interface IHolidayStateOffice {
//   officeList: IOffice[];
// }

const AddHolidayModal = ({
  isOpen,
  onClose,
  EditHolidaysData,
  setState,
  getHoliday,
}: IAddHolidayModal) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  // const [stateOffice, setStateOffice] = useState<IHolidayStateOffice>({
  //   officeList: [],
  // });
  const {
    register,
    reset,
    formState: { errors },
    handleSubmit,
    setValue,
    clearErrors,
  } = useForm<IHolidayModalForm>();

  useEffect(() => {
    if (isOpen) {
      // GetOfficeList();
    }
    if (EditHolidaysData !== null) {
      const holidayDate = moment(EditHolidaysData?.holidayDate).format(
        'YYYY-MM-DD',
      );
      setValue('holidayName', EditHolidaysData?.holidayName);
      setValue('holidayDate', holidayDate);
      setValue('description', EditHolidaysData?.description);
    } else {
      reset();
    }
  }, [EditHolidaysData, isOpen]);

  // const GetOfficeList = async () => {
  //   try {
  //     const API = `${API_URL}${API_ENDPOINT?.getSite}?type=office`;
  //     const response: IOfficeResponse = await callApi(API, { method: 'GET' });
  //     if (response?.status) {
  //       // printData(response);
  //       setStateOffice((pre) => ({
  //         ...pre,
  //         officeList: response?.data?.site,
  //       }));
  //     } else {
  //       showToastNotification('success', response?.message);
  //     }
  //   } catch (error) {
  //     if (error && typeof error === 'object' && 'message' in error) {
  //       showToastNotification('danger', (error as IApiErrorResponse).message);
  //     } else {
  //       showToastNotification('danger', 'Something went wrong');
  //     }
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const onSubmit: SubmitHandler<IHolidayModalForm> = async (data) => {
    try {
      const postData = {
        holidayName: data?.holidayName,
        holidayDate: data?.holidayDate,
        description: data?.description,
      };
      setIsLoading(true);
      const API =
        EditHolidaysData !== null
          ? API_URL +
            API_ENDPOINT?.addHoliday +
            `?holidayId=${EditHolidaysData?.id}`
          : API_URL + API_ENDPOINT?.addHoliday;

      const response: IOfficeResponse = await callApi(API, {
        method: 'POST',
        data: postData,
      });
      setIsLoading(false);
      if (response?.status === true) {
        showToastNotification('success', response?.message);
        getHoliday();
        setState((pre) => ({ ...pre, EditHolidaysData: null }));
        onClose();
        reset();
      } else {
        showToastNotification('danger', response?.message);
        reset();
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      className="modal-dialog modal-dialog-centered modal-md"
      isOpen={isOpen}
      toggle={() => {
        clearErrors();
        onClose();
        reset();
        setState((pre) => ({ ...pre, EditHolidaysData: null }));
      }}
    >
      <div className="modal-content shadow-lg">
        <div className="modal-header p-4">
          <h1
            className="modal-title fs-3 rajdhani-semibold"
            id="addHolidayModalLabel"
          >
            {EditHolidaysData ? 'Edit' : 'Add'} Holiday
          </h1>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              clearErrors();
              onClose();
              reset();
              setState((pre) => ({ ...pre, EditHolidaysData: null }));
            }}
          />
        </div>
        <div className="modal-body p-4">
          <form onSubmit={handleSubmit(onSubmit)} id="formholiday">
            <div className="card shadow-none mb-0">
              <div className="card-body p-0">
                <div className="row">
                  {/* <div className="col-12">
                    <div className="form-group mb-3">
                      <label htmlFor="officeId" className="form-label">
                        Office <span className="text-danger">*</span>
                      </label>
                      <select
                        className={`form-control ${errors.officeId ? 'is-invalid' : ''}`}
                        id="officeId"
                        {...register('officeId', {
                          required: 'Holiday Name is required',
                        })}
                      >
                        <option value="" hidden>
                          Select Office
                        </option>
                        {stateOffice?.officeList.length > 0 ? (
                          stateOffice?.officeList?.map((item) => {
                            return (
                              <option value={item?.id}>{item?.name}</option>
                            );
                          })
                        ) : (
                          <option value="" hidden>
                            Not Data Found
                          </option>
                        )}
                      </select>
                      {errors.officeId && (
                        <div className="form-text text-danger">
                          {errors.officeId.message}
                        </div>
                      )}
                    </div>
                  </div> */}
                  <div className="col-12">
                    <div className="form-group mb-3">
                      <label htmlFor="holidayName" className="form-label">
                        Holiday Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.holidayName ? 'is-invalid' : ''}`}
                        id="holidayName"
                        placeholder="Holiday Name"
                        {...register('holidayName', {
                          ...errorTypes.required('Holiday'),
                          ...errorTypes.holidayName,
                        })}
                      />
                      {errors.holidayName && (
                        <div className="form-text text-danger">
                          {errors.holidayName.message}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group mb-3">
                      <label htmlFor="holidayDate" className="form-label">
                        Holiday Date <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        className={`form-control ${errors.holidayDate ? 'is-invalid' : ''}`}
                        id="holidayDate"
                        {...register('holidayDate', {
                          required: 'Holiday Date is required',
                        })}
                        min={moment().format('YYYY-MM-DD')}
                        defaultValue={moment().format('YYYY-MM-DD')}
                      />
                      {errors.holidayDate && (
                        <div className="form-text text-danger">
                          {errors.holidayDate.message}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group mb-3">
                      <label htmlFor="description" className="form-label">
                        Description <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                        rows={3}
                        id="description"
                        placeholder="Enter Description here"
                        {...register('description', {
                          required: 'Description is required',
                        })}
                      />
                      {errors.description && (
                        <div className="form-text text-danger">
                          {errors.description.message}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="modal-footer p-4">
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => {
              clearErrors();
              onClose();
              reset();
              setState((pre) => ({ ...pre, EditHolidaysData: null }));
            }}
          >
            Cancel
          </button>
          <button type="submit" className="btn btn-primary" form="formholiday">
            {isLoading ? (
              <Spinner />
            ) : EditHolidaysData ? (
              'Edit Holidays'
            ) : (
              'Add Holiday'
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AddHolidayModal;
